import React from 'react';
import { Sparkles, DollarSign, Activity } from 'lucide-react';
import { Kpi } from './_shared';

export default function AiTab({ ai }) {
  if (!ai) return <div className="text-slate-500 text-sm">Loading…</div>;
  return (
    <div className="space-y-4" data-testid="governance-ai">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        <Kpi icon={Sparkles} label="AI calls (30d)" value={ai.total_calls || 0} />
        <Kpi icon={DollarSign} label="Est. cost (30d)" value={`$${(ai.total_cost || 0).toFixed(2)}`} />
        <Kpi icon={Activity} label="Distinct models" value={(ai.models || []).length} />
      </div>
      <div className="rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900/50 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 dark:bg-slate-900 text-xs uppercase text-slate-500">
            <tr>
              <th className="px-4 py-2 text-left">Model</th>
              <th className="px-4 py-2 text-right">Calls</th>
              <th className="px-4 py-2 text-right">Tokens</th>
              <th className="px-4 py-2 text-right">Est. cost</th>
              <th className="px-4 py-2 text-right">Last used</th>
            </tr>
          </thead>
          <tbody>
            {(ai.models || []).map((m, i) => (
              <tr key={m.model + i} className="border-t border-slate-100 dark:border-slate-800">
                <td className="px-4 py-2 font-mono text-xs text-slate-700 dark:text-slate-300">{m.model}</td>
                <td className="px-4 py-2 text-right tabular-nums">{m.calls}</td>
                <td className="px-4 py-2 text-right tabular-nums">{(m.tokens || 0).toLocaleString()}</td>
                <td className="px-4 py-2 text-right tabular-nums">${m.cost.toFixed(4)}</td>
                <td className="px-4 py-2 text-right text-slate-500">{m.last_used ? new Date(m.last_used).toLocaleDateString() : '—'}</td>
              </tr>
            ))}
            {(ai.models || []).length === 0 && (
              <tr><td colSpan={5} className="px-4 py-8 text-center text-slate-400">No AI activity yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
